module.exports = __webpack_public_path__ + "static/coloring_book_flyer.d6849a14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/coloring_book_flyer.jpg
// module id = 493
// module chunks = 35783957827783